import {
  DISPLAY_FONTSIZE_DECREASE,
  DISPLAY_FONTSIZE_INCREASE,
  DISPLAY_IS_EDIT_SET,
  DISPLAY_IS_ORIGIN_SET,
  DISPLAY_LEFT_SIDE_WIDTH_SET,
  DISPLAY_RIGHT_SIDE_WIDTH_SET,
} from "./constants";
import {
  DisplayActions,
  SetIsEdit,
  SetIsOrigin,
  SetLeftSideWidth,
  SetRightSideWidth,
} from "./actionTypes";
import { IDisplayState } from "./IDisplayState";

import { SUBSCRIBE_TO_RECORD_SUCCESS } from "../library/constants";
import { SubscribeToRecordSuccess } from "../library/actionTypes";

import { fontSizes } from "../../../theme";

const initialState: IDisplayState = {
  fontSize: Math.floor(fontSizes.length / 2),
  isEdit: false,
  isOrigin: false,
  leftSideWidth: 25,
  rightSideWidth: 25,
};

type Actions = DisplayActions | SubscribeToRecordSuccess;

export function displayReducer(state = initialState, { type, ...action }: Actions): IDisplayState {
  switch (type) {
    case DISPLAY_FONTSIZE_DECREASE:
      return ({
        ...state,
        fontSize: state.fontSize - 1,
      });

    case DISPLAY_FONTSIZE_INCREASE:
      return ({
        ...state,
        fontSize: state.fontSize + 1,
      });

    case DISPLAY_IS_EDIT_SET: {
      const { payload } = action as SetIsEdit;

      return ({
        ...state,
        isEdit: payload,
        ...(payload ? {isOrigin: false} : {})
      });
    }

    case SUBSCRIBE_TO_RECORD_SUCCESS: {
      const { isOrigin } = state;
      const {
        payload: {
          book: {
            bookType,
          },
        },
      } = action as SubscribeToRecordSuccess;

      return ({
        ...state,
        isOrigin: isOrigin ? ["FILE", "PDF"].includes(bookType.toUpperCase()) : isOrigin,
      });
    }

    case DISPLAY_IS_ORIGIN_SET: {
      const { payload } = action as SetIsOrigin;

      return ({
        ...state,
        isOrigin: payload as boolean,
        ...(payload ? {isEdit: false} : {})
      });
    }

    case DISPLAY_LEFT_SIDE_WIDTH_SET: {
      const { payload } = action as SetLeftSideWidth;

      return ({
        ...state,
        leftSideWidth: payload,
      });
    }

    case DISPLAY_RIGHT_SIDE_WIDTH_SET: {
      const { payload } = action as SetRightSideWidth;

      return ({
        ...state,
        rightSideWidth: payload,
      });
    }

    default:
      return state;
  }
}


